module.exports = __webpack_public_path__ + "img/venue-gray-1.c8658434.png";